/**
 * useCms — small hook that fetches sanitized, published CMS content.
 * Falls back to local defaults so the public site never breaks if the
 * CMS has not been seeded.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";

let _bundleCache = null;
let _bundlePromise = null;

async function fetchBundle(force = false) {
  if (!force && _bundleCache) return _bundleCache;
  if (_bundlePromise) return _bundlePromise;
  _bundlePromise = api.get("/cms/public/bundle").then(({ data }) => {
    _bundleCache = data.blocks || {};
    _bundlePromise = null;
    return _bundleCache;
  }).catch(() => {
    _bundlePromise = null;
    return {};
  });
  return _bundlePromise;
}

export function useCms(blockKey, fallback) {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let cancel = false;
    fetchBundle().then((bundle) => {
      if (cancel) return;
      const d = bundle[blockKey]?.data;
      if (d) setData(d);
    });
    return () => { cancel = true; };
  }, [blockKey]);
  return data;
}

export function useCmsBundle(keys) {
  const [blocks, setBlocks] = useState({});
  useEffect(() => {
    let cancel = false;
    fetchBundle().then((b) => { if (!cancel) setBlocks(b); });
    return () => { cancel = true; };
  }, [keys]);
  return blocks;
}
